import { useEffect, useState } from "react";
import { ContactForm } from "@/components/contact-form";
import { useContactOverlay } from "@/components/contact-overlay-context";
import { OverlayCloseButton, OverlayPanel, overlayBackdropClassName } from "@/components/ui/overlay-shell";
import { fetchSiteContent } from "@/lib/services/site-content.service";

export function ContactOverlay() {
  const { isOpen, closeContact, defaults } = useContactOverlay();
  const [content, setContent] = useState<any>({});

  useEffect(() => {
    fetchSiteContent('contact_overlay').then(data => {
      if (data?.content) setContent(data.content);
    }).catch(console.error);
  }, []);

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeContact();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, closeContact]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" onClick={(e) => { if (e.target === e.currentTarget) closeContact(); }}>
      <div
        aria-hidden="true"
        className={`${overlayBackdropClassName} pointer-events-none`}
      />

      <OverlayPanel className="w-full h-auto max-h-full sm:max-h-[88vh] max-w-2xl flex flex-col">
        <div className="flex items-start justify-between gap-4 border-b border-white/10 px-5 pt-8 pb-5 shrink-0 md:px-6 md:pt-5">
          <div className="min-w-0">
            <h3 className="text-xl font-bold tracking-tight">{content.title || "Kontakt"}</h3>
            <p className="mt-1 text-sm text-white/60">{content.subtitle || "Wir melden uns schnellstmöglich zurück."}</p>
          </div>

          <OverlayCloseButton onClick={closeContact} />
        </div>

        <div className="overflow-y-auto overscroll-contain p-5 md:p-6">
          <ContactForm
            key={`${defaults.category}`}
            defaults={defaults}
            onSuccess={closeContact}
            labels={content}
          />
        </div>
      </OverlayPanel>
    </div>
  );
}
